import './index.css'

import {createRoot} from 'react-dom/client'

import {DataRefreshProvider} from "@/providers/refresh-context.tsx";

import App from './app/App.tsx'


createRoot(document.getElementById('app')!).render(
    <DataRefreshProvider>
        <App/>
    </DataRefreshProvider>
)
